import * as React from 'react'
import { IDVStatus } from '../../../utilities/steps'
import * as actions from '../../../actions'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { connect } from 'react-redux'
import Loading from '@doordash/component-loading'
import { Action } from 'redux'
import { get } from 'lodash'
import useSessionToken from '../../../hooks/useSessionToken'
import usePersonaClient from '../../../hooks/usePersonaClient'
import isCitizenOfApplicationCountry from '../../../utilities/applicant/isCitizenOfApplicationCountry'
import shouldGetSessionToken from '../../../utilities/persona/shouldGetSessionToken'
import { Application } from '../../../utilities/application/application'
import getTemplateId from '../../../utilities/persona/determineTemplateId'

export type PersonaClientCallbackProps = {
  idVerificationStatus: IDVStatus
  triggerPersonaClientRender?: boolean
}

type PersonaClientProps = {
  referenceId?: string
  vehicleType?: string
  onUpdate?: (personaClientCallbackProps: PersonaClientCallbackProps) => void
  /* TODO replace to Action with ThunkAction when we upgrade Typescript to support unknown */
  trackIdentityVerificationSteps?: (
    data: DA.IdentityVerificationEvents
  ) => Action
  updateIdvStatus?: (
    referenceId: string,
    inquiryId: string,
    event: string,
    polling: boolean
  ) => Promise<void>
  idvStatus?: {
    value?: string
    isSubmitting?: boolean
    isSubmitted?: boolean
  }
  triggerPersonaClientRender: boolean
  isIDVReferral: boolean
  application?: Application
}

export const TemplateIdTypes = {
  motorized: ['tmpl_kfaFkGugqG9jqh6aAuc21Vwd', 'tmpl_7d8pqQoJhwLHL1x38nBfpCuu'],
  'non-motorized': [
    'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
    'tmpl_9pdz4FX6uwqATzxyQPTc1RYP',
  ],
}

/**
 * IMPROVE @alexkim-doordash: Make this component into a hook and if need be,
 * use the hook in a wrapper to call the Loading component
 */
export const PersonaClient: React.FC<PersonaClientProps> = ({
  referenceId,
  vehicleType,
  onUpdate,
  trackIdentityVerificationSteps,
  updateIdvStatus,
  triggerPersonaClientRender,
  isIDVReferral = false,
  application,
}) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const isSessionTokenFetchingEnabled = shouldGetSessionToken(
    application,
    isIDVReferral
  )
  const sessionToken = useSessionToken({
    referenceId,
    inquiryId: application.identityInquiryId,
    onSessionTokenRetrieval: trackIdentityVerificationSteps,
    isEnabled: isSessionTokenFetchingEnabled,
  })

  const isCitizen = isCitizenOfApplicationCountry(application)

  const templateId = sessionToken
    ? null
    : getTemplateId(vehicleType, application.country, {
        isIDVReferral,
        isCitizen,
      })

  const inquiryId = sessionToken ? application.identityInquiryId : null

  const email = get(application, 'email', '')

  usePersonaClient({
    email,
    sessionToken,
    referenceId,
    inquiryId,
    templateId,
    updateIdvStatus,
    onUpdate,
    trackIdentityVerificationSteps,
    setIsLoading,
    triggerPersonaClientRender,
  })

  return isLoading ? <Loading /> : null
}

const mapStateToProps = state => ({
  idvStatus: state.idvStatus,
  application: state.application,
})

const mapDispatchToProps = {
  updateIdvStatus: actions.updateIdvStatus,
  trackIdentityVerificationSteps: events.trackIdentityVerificationSteps,
}
export default connect(mapStateToProps, mapDispatchToProps)(PersonaClient)
